<template>
  <div class="hold-transition">
    <div
      class="modal fade"
      id="modal-form-vehiculos-postulados"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Vehiculos Postulados</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal-vehiculos-postulados"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body table-responsive">
            <table
              class="table table-bordered table-striped table-hover table-sm mb-0"
            >
              <thead class="bg-dark">
                <tr>
                  <th class="text-center">Empresa</th>
                  <th class="text-center">Tipo de Vehiculo</th>
                  <th class="text-center">Placa</th>
                  <th class="text-center">Conductor</th>
                  <th class="text-center">Fecha de Postulacion</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in postulaciones.data || []" :key="item.id">
                  <td>
                    {{
                      item.tep_det_nominacion &&
                        item.tep_det_nominacion.tep_transportadora.razon_social
                    }}
                  </td>
                  <td>
                    {{
                      item.tep_det_nominacion &&
                        item.tep_det_nominacion.tep_tipos_vehiculos.nombre
                    }}
                  </td>
                  <td>{{ item.vehiculo ? item.vehiculo.placa : "" }}</td>
                  <td>
                    {{
                      item.conductor
                        ? item.conductor.nombres +
                          " " +
                          item.conductor.apellidos
                        : ""
                    }}-
                    {{ item.conductor ? item.conductor.numero_documento : "" }}
                  </td>
                  <td>
                    {{ item.fecha }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="mt-2"
              v-if="postulaciones.data && postulaciones.data.length"
            >
              <div class="float-left" v-if="postulaciones.total">
                <p>
                  Mostrando del <b>{{ postulaciones.from }}</b> al
                  <b>{{ postulaciones.to }}</b> de un total:
                  <b>{{ postulaciones.total }}</b> Registros
                </p>
              </div>
              <pagination
                :data="postulaciones"
                @pagination-change-page="
                  listaDeVehiculosPostulados(empresaId, nominacionId, $event)
                "
                :limit="5"
                align="right"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";

export default {
  name: "ModalVehiculosPostulados",
  components: {
    pagination,
  },
  data() {
    return {
      postulaciones: {},
      empresaId: null,
      nominacionId: null,
    };
  },
  methods: {
    listaDeVehiculosPostulados(empresaId, nominacionId, page = 1) {
      this.empresaId = empresaId || this.empresaId;
      this.nominacionId = nominacionId || this.nominacionId;
      axios
        .get("/api/tep/postulaciones/vehiculosPostulados", {
          params: {
            empresa_id: this.empresaId,
            nominacion_id: this.nominacionId,
            page,
          },
        })
        .then(({ data }) => (this.postulaciones = data));
    },
  },
};
</script>
